// Sélectionnez tous les éléments avec la classe "quick-product__btn"
var buttons = document.querySelectorAll(".quick-product__btn");

// Parcourez tous les boutons et ajoutez un gestionnaire d'événement pour le clic
buttons.forEach(function(button) {
  button.addEventListener("click", function() {
    // Utilisez setTimeout pour exécuter playPappLoad() après 1 seconde
    setTimeout(function() {
      playerPappLoad(); // Appel de la fonction playPappLoad() après 1 seconde
    }, 1000); // Délai de 1 seconde (1000 millisecondes)
  });
});

// La fonction playPappLoad() que vous souhaitez exécuter
function playPappLoad() {
  // Code de votre fonction playPappLoad() ici
  console.log("La fonction playPappLoad() a été exécutée après 1 seconde !");
}

// Fonction pour arrêter tous les lecteurs multimédias
function stopAllMediaPlayers() {
  for (var playerId in mejs.players) {
    if (mejs.players.hasOwnProperty(playerId)) {
      var mediaPlayer = mejs.players[playerId];
      mediaPlayer.pause();
      mediaPlayer.setCurrentTime(0);
    }
  }
}

// Fonction à exécuter lorsque la div avec ID commençant par "QuickShopModal" est à "display: none"
function onModalHidden() {
  // Code à exécuter
  stopAllMediaPlayers(); // Par exemple, arrêter tous les lecteurs multimédias
}

// Sélectionnez tous les éléments dont l'ID commence par "QuickShopModal"
var modalElements = document.querySelectorAll('[id^="QuickShopModal"]');

// Créez un observateur d'intersection
var observer = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.target.id.startsWith("QuickShopModal")) {
      if (entry.intersectionRatio === 0) {
        // L'élément avec l'ID commençant par "QuickShopModal" n'est pas visible (display: none)
        onModalHidden();
      }
    }
  });
}, { threshold: 0 });

// Observez tous les éléments sélectionnés
modalElements.forEach(function(modalElement) {
  observer.observe(modalElement);
});